import {Container, ThemeProvider} from '@mui/material';
import defaultTheme from '../components/Themes/defaultTheme';
import "../assets/css/main.css"
import { Typography } from '@mui/material/node';

export const CommingSoon = () => {
  return (
    <>
    <ThemeProvider theme={defaultTheme}>
      <Container disableGutters maxWidth="lg" component="main" sx={{ pt: 2, pb: 6 }} align>
        <Typography variant="h1" sx={{
                        marginTop: "20px",
                        textAlign: "center",
                        fontWeight: "800",
                        fontSize: {
                            xs: "58px",
                            md: "68px",
                        },
                        lineHeight: "62px",
                        mb: 4,
                    }}>NC</Typography>
        <Typography variant="body1" sx={{
                        marginTop: "20px",
                        textAlign: "center",
                        fontWeight: "800",
                        fontSize: {
                            xs: "20px",
                            md: "28px",
                        },
                        lineHeight: "62px",
                        mb: 4,
                    }}>Comming Soon</Typography>
      </Container>
      </ThemeProvider>
    </>
  );
};